<template>
  <main class="mx-auto max-w-4xl px-4 py-12">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-3xl font-bold tracking-tight text-zinc-900 dark:text-zinc-50">My Stories</h1>
        <p class="mt-1 text-zinc-500 dark:text-zinc-400">Your saved creations, all in one place.</p>
      </div>
      <router-link
        to="/create"
        class="shrink-0 whitespace-nowrap rounded-2xl bg-gradient-to-r from-violet-600 to-indigo-500 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-violet-500/25 transition hover:shadow-violet-500/40"
      >
        + New Story
      </router-link>
    </div>

    <!-- Loading -->
    <div v-if="store.isLoadingHistory" class="flex items-center justify-center py-24">
      <div class="h-10 w-10 animate-spin rounded-full border-4 border-violet-500 border-t-transparent" />
    </div>

    <!-- Error -->
    <div
      v-else-if="store.error"
      class="mt-8 rounded-2xl border border-red-500/20 bg-red-500/5 p-8 text-center"
    >
      <p class="text-sm text-red-500 dark:text-red-400">{{ store.error }}</p>
      <button
        @click="store.loadStories()"
        class="mt-4 rounded-xl border border-red-500/30 px-4 py-2 text-sm font-medium text-red-500 transition hover:border-red-500/50 dark:text-red-300"
      >
        Retry
      </button>
    </div>

    <!-- Empty state -->
    <div
      v-else-if="store.stories.length === 0"
      class="mt-16 flex flex-col items-center text-center"
    >
      <div class="flex h-20 w-20 items-center justify-center rounded-full bg-zinc-100 dark:bg-surface-dark">
        <svg class="h-10 w-10 text-zinc-300 dark:text-zinc-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"/>
        </svg>
      </div>
      <h2 class="mt-6 text-lg font-semibold text-zinc-900 dark:text-zinc-50">No stories yet</h2>
      <p class="mt-2 text-sm text-zinc-500 dark:text-zinc-400">Create your first AI-powered story and it will appear here.</p>
      <router-link
        to="/create"
        class="mt-6 rounded-2xl bg-gradient-to-r from-violet-600 to-indigo-500 px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-violet-500/25"
      >
        Create a Story
      </router-link>
    </div>

    <!-- Stories grid -->
    <div v-else class="mt-8 grid gap-4 sm:grid-cols-2">
      <StoryCard
        v-for="story in store.stories"
        :key="story.id"
        :story="story"
      />
    </div>
  </main>
</template>

<script setup>
import { onMounted } from 'vue';
import { useStoryStore } from '@/stores/story';
import StoryCard from '@/components/StoryCard.vue';

const store = useStoryStore();

onMounted(() => {
  store.loadStories();
});
</script>
